import { observer } from 'mobx-react-lite';

import { RemoteStorageCredentialsUpdater } from '@gem/modules/remote-storage';

import Entities from 'STORE';

import { CalendarRealtimeSubscriber } from './CalendarRealtimeSubscriber/CalendarRealtimeSubscriber';
import { DirectionHandler } from './DirectionHandler/DirectionHandler';
import { DomainMigrateHandler } from './DomainMigrateHandler/DomainMigrateHandler';
import { IsBackNavigationHandler } from './IsBackNavigationHandler/IsBackNavigationHandler';
import { NavigationHandler } from './NavigationHandler/NavigationHandler';
import { OfflineStatusHandler } from './OfflineStatusHandler/OfflineStatusHandler';
import { ResizeListener } from './ResizeListener/ResizeListener';
import { ThemeHandler } from './ThemeHandler/ThemeHandler';
import { UnauthorizedDeepLinkHandler } from './UnauthorizedDeepLinkHandler/UnauthorizedDeepLinkHandler';

export const Modules = observer(() => {
  return (
    <>
      <UnauthorizedDeepLinkHandler />
      <DomainMigrateHandler />
      <NavigationHandler />
      <ThemeHandler />
      <DirectionHandler />
      <ResizeListener />
      <IsBackNavigationHandler />
      <OfflineStatusHandler />
      <RemoteStorageCredentialsUpdater isAuthenticated={Entities.authStore.isAuthenticated} />
      {Entities.featuresStore.isCalendarIntegrationEnabled && <CalendarRealtimeSubscriber />}
    </>
  );
});
